<!-- ========== FOOTER ========== -->
<footer class="bg-footer">
  <div class="container-header">
    <div class="footer__footer-container row position-relative pb-6 pb-xl-0">
      <div
        class="footer__footer-logo col-md-2 col-12 mb-2 mb-md-0 text-center text-md-start"
      >
        <!-- Logo -->
        <img
          *ngIf="
            bookingModuleConfig?.isActive &&
            (primaryWhiteLogoUrl$ | async)?.length
          "
          class="logo"
          [src]="primaryWhiteLogoUrl$ | async"
          alt="logo"
          height="50"
          [routerLink]="getLandingPageRedirect()"
        />
        <img
          *ngIf="
            !bookingModuleConfig?.isActive &&
            (primaryWhiteLogoUrl$ | async)?.length
          "
          class="logo"
          [src]="primaryWhiteLogoUrl$ | async"
          alt="logo"
          height="50"
          [routerLink]="appRoutesNS.Shop.SHOP"
        />
        <!-- End Logo -->
      </div>
      <div class="footer__footer-body col-md-8">
        <!-- Copyright -->
        <div class="w-100 text-center mx-md-auto">
          <div [innerHTML]="footerBody$ | async"></div>
          <p class="text-white small nav-link">
            <a href="https://www.delcom.nl/" target="_blank">
              &copy; Powered by Delcom</a
            >
          </p>
        </div>
        <!-- End Copyright -->
      </div>
    </div>
  </div>
</footer>
<!-- ========== END FOOTER ========== -->
